/** What the public premise page shows: the timetable of events, or the reservation wizard. */
export enum PublicPageView {
  Timetable = 'timetable',
  Reservations = 'reservations',
}
